import { stationFlash, stationStats, siteDate, topStory } from "@/mocks/blackmole";
import { solidTone, textTone } from "./tone";

export default function StationHero() {
  return (
    <section id="station" className="scroll-mt-24 border-b border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-10 md:px-6 md:py-12">
        <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
          <div className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-700">
            <span className="inline-block h-px w-6 bg-primary-500"></span>
            今日站台 · 快讯速递不设缓冲
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-calendar-line text-sm"></i>
            <span className="whitespace-nowrap">{siteDate} · 信源监测中</span>
          </div>
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          <article className="lg:col-span-2">
            <div className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6 md:p-8">
              <div className="mb-4 flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-flag-fill text-xs"></i>
                  突发追踪
                </span>
                <span className="text-xs font-medium tracking-wide text-primary-700">顶栏抢鲜</span>
              </div>

              <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[34px] md:leading-tight">
                {topStory.title}
              </h2>

              <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600">
                {topStory.lead}
              </p>

              <div className="mt-4 flex flex-wrap gap-2">
                {topStory.meta.map((m) => (
                  <span
                    key={m}
                    className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900"
                  >
                    {m}
                  </span>
                ))}
              </div>

              <div className="mt-auto flex flex-wrap items-center gap-3 pt-6">
                <a
                  href="#feed"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-time-line text-sm"></i>
                  进站追更新
                </a>
                <a
                  href="#deep"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className="ri-eye-line text-sm"></i>
                  看完整内幕
                </a>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-5">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <div className="mb-3 flex items-center justify-between">
                <span className="flex items-center gap-1.5 text-sm font-semibold text-foreground-900">
                  <i className="ri-radar-line text-primary-600"></i>
                  实时速报
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-primary-500"></span>
                  LIVE
                </span>
              </div>
              <ul className="divide-y divide-background-100">
                {stationFlash.map((f, i) => (
                  <li
                    key={i}
                    className="group flex cursor-pointer items-start gap-3 py-3 first:pt-1 last:pb-1"
                  >
                    <span className={`mt-0.5 shrink-0 text-xs font-bold ${textTone[f.tone as keyof typeof textTone]}`}>
                      {f.time}
                    </span>
                    <span className="text-sm leading-relaxed text-foreground-700 transition-colors group-hover:text-foreground-950">
                      {f.title}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {stationStats.map((s) => (
                <div
                  key={s.label}
                  className={`flex flex-col justify-center gap-1 rounded-xl p-4 ${solidTone[s.tone as keyof typeof solidTone]}`}
                >
                  <span className="font-heading text-2xl font-black leading-none">{s.value}</span>
                  <span className="text-xs opacity-90">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}